import * as Yup from "yup";

/**
 * Roles whose company is optional in the user form (S3DEV2-7821).
 *
 * S3 staff — Administrators and Sleep Coaches — belong to S3's own company.
 * When a create posts no company_id the API places them there itself
 * (UsersSerializer.Company in Phoenix_Back_End), and an edit that posts an
 * empty company_id leaves the stored company untouched. Requiring the field
 * for them blocked every Sleep Coach edit (S3DEV2-7647 follow-up): the
 * company dropdown only lists the editor's own accessible companies, so a
 * Sleep Coach's company often is not an option to pre-select.
 *
 * Every other role (Company / Office Administrator) still has to pick a
 * company — the API rejects those creates without one.
 */
export const COMPANY_OPTIONAL_ROLES = ["Administrator", "SleepCoach"];

export const isCompanyRequired = role => !COMPANY_OPTIONAL_ROLES.includes(role);

/** company_id rule for the user form schema; reads the sibling `role`. */
export const companyIdSchema = Yup.string().when("role", {
  is: role => !isCompanyRequired(role),
  then: schema => schema.notRequired(),
  otherwise: schema => schema.required("Required")
});
